// extracted by mini-css-extract-plugin
export default {"stakingMenu":"StakingAction_stakingMenu__QQh-W","menuBar":"StakingAction_menuBar__PHXkm"};